import React, { useEffect, useState, Suspense, lazy, createElement, Component } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// Lazy load modal pages
const TermsAndConditions = lazy(() => import('./pages/TermsAndConditions').then(m => ({
  default: m.TermsAndConditions
})));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy').then(m => ({
  default: m.PrivacyPolicy
})));
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
// Lightweight Modal Component
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <>
      <div className="modal-backdrop fade-in" onClick={onClose} data-id="element-0" />
      <div className="modal" data-id="element-1">
        <div className="modal-content modal-in" data-id="element-2">
          <div className="modal-header" data-id="element-3">
            <h2 className="font-serif text-white text-xl md:text-2xl" data-id="element-4">
              {title}
            </h2>
            <button onClick={onClose} className="text-gray transition" style={{
            fontSize: '2rem',
            lineHeight: 1,
            background: 'none',
            border: 'none',
            color: '#9CA3AF',
            cursor: 'pointer'
          }} aria-label="Cerrar" data-id="element-5">
              ×
            </button>
          </div>
          <div className="modal-body" data-id="element-6">{children}</div>
        </div>
      </div>
    </>;
}
function Home() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 9
  });
  const [unitsLeft] = useState(23);
  const [openModal, setOpenModal] = useState<'terms' | 'privacy' | null>(null);
  // Meta Pixel - Deferred 2 seconds
  useEffect(() => {
    const loadPixel = () => {
      !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          b.head.appendChild(t);
        }
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
      window.fbq('init', '1377433624081067');
      window.fbq('track', 'PageView');
    };
    const timer = setTimeout(loadPixel, 2000);
    return () => clearTimeout(timer);
  }, []);
  // Countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };else if (prev.minutes > 0) return {
          minutes: prev.minutes - 1,
          seconds: 59
        };else return {
          minutes: 14,
          seconds: 9
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const handlePaymentClick = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'El Reinicio Biológico',
        content_ids: ['reinicio-biologico'],
        content_type: 'product',
        value: 26.0,
        currency: 'EUR'
      });
    }
    window.open('https://pay.hotmart.com/W104988940M?bid=1774468896416', '_blank');
  };
  return <div style={{
    width: '100%',
    minHeight: '100vh',
    background: '#fff'
  }} data-id="element-7">
      {/* STICKY URGENCY BAR */}
      <div className="sticky-bar" data-id="element-8">
        <div className="container flex flex-col md:flex-row items-center justify-between gap-3" style={{
        paddingTop: '0.75rem',
        paddingBottom: '0.75rem'
      }} data-id="element-9">
          <div className="flex items-center gap-2 text-xs md:text-sm font-semibold" data-id="element-10">
            <span style={{
            fontSize: '1.125rem'
          }} data-id="element-11">
              ⚡
            </span>
            <span className="uppercase" data-id="element-12">
              OFERTA DE LANZAMIENTO — SOLO QUEDAN {unitsLeft} UNIDADES
            </span>
          </div>
          <div className="flex items-center gap-2 font-bold text-sm md:text-base" style={{
          background: '#7F1D1D',
          padding: '0.5rem 1rem',
          borderRadius: '0.5rem'
        }} data-id="element-13">
            <span className="text-xs md:text-sm" data-id="element-14">EXPIRA EN:</span>
            <span style={{
            fontSize: '1.125rem',
            minWidth: '90px',
            fontVariantNumeric: 'tabular-nums'
          }} data-id="element-15">
              00:{String(timeLeft.minutes).padStart(2, '0')}:
              {String(timeLeft.seconds).padStart(2, '0')}
            </span>
          </div>
          <button onClick={handlePaymentClick} className="btn btn-primary w-full md:w-auto text-sm md:text-base whitespace-nowrap" data-id="element-16">
            CONSEGUIR POR 26€ →
          </button>
        </div>
      </div>

      {/* HERO SECTION */}
      <section className="hero" data-id="element-17">
        <div className="container" style={{
        maxWidth: '56rem',
        textAlign: 'center'
      }} data-id="element-18">
          <p className="text-gold text-xs md:text-sm uppercase font-semibold mb-6 fade-in-up" style={{
          letterSpacing: '0.1em'
        }} data-id="element-19">
            EL PROTOCOLO QUE NADIE EN ESPAÑA TE HABÍA CONTADO
          </p>

          <h1 className="font-serif text-white text-3xl md:text-5xl leading-tight mb-6 fade-in-up" style={{
          animationDelay: '0.1s'
        }} data-id="element-20">
            ¿Por qué te sientes agotado, hinchado y sin foco... aunque 'hagas
            todo bien'?
          </h1>

          <h2 className="text-gold text-xl md:text-2xl mb-8 font-semibold fade-in-up" style={{
          animationDelay: '0.2s'
        }} data-id="element-21">
            No es tu edad. No es el estrés. Es Inflamación Silenciosa
            destruyendo tu biología.
          </h2>

          <p className="text-white text-base md:text-lg leading-relaxed mb-12 mx-auto fade-in-up" style={{
          maxWidth: '42rem',
          animationDelay: '0.3s'
        }} data-id="element-22">
            Tu cuerpo está librando una guerra invisible 24 horas al día.
            Microorganismos oportunistas en tu intestino están secuestrando tu
            energía, nublando tu cerebro y deformando tu vientre. El Reinicio
            Biológico apaga ese incendio interno en solo 14 días. Sin dietas
            extremas. Sin pastillas. Solo protocolo técnico basado en ciencia
            real.
          </p>

          <div className="mb-12 fade-in-up" style={{
          animationDelay: '0.4s'
        }} data-id="element-23">
            <picture data-id="element-24">
              <source type="image/webp" srcSet="https://cdn.magicpatterns.com/uploads/kpqeeJXPW4oe2uvVr6ePv9/LIBRO_EL_REINICIO_BIOLOGICO_2B_BONOS_(1)_(1).png" data-id="element-25" />
              <img src="https://cdn.magicpatterns.com/uploads/kpqeeJXPW4oe2uvVr6ePv9/LIBRO_EL_REINICIO_BIOLOGICO_2B_BONOS_(1)_(1).png" alt="El Reinicio Biológico - Protocolo de 14 Días" width="390" height="390" loading="eager" fetchPriority="high" style={{
              width: '100%',
              maxWidth: '390px',
              height: 'auto',
              margin: '0 auto',
              display: 'block'
            }} data-id="element-26" />
            </picture>
          </div>

          <div className="mb-8" data-id="element-27">
            <p className="text-lg md:text-xl mb-2" style={{
            color: '#EF4444'
          }} data-id="element-28">
              <span className="price-strike" data-id="element-29">Valor total: 205€</span>
            </p>
            <p className="text-gold text-4xl md:text-6xl font-serif font-bold mb-2" data-id="element-30">
              HOY SOLO: 26€
            </p>
            <p className="text-sm" style={{
            color: '#9CA3AF'
          }} data-id="element-31">
              (IVA incluido. Acceso inmediato.)
            </p>
          </div>

          <button onClick={handlePaymentClick} className="btn btn-primary text-lg md:text-xl mb-6" style={{
          minHeight: '56px',
          padding: '1rem 3rem'
        }} data-id="element-32">
            🚀 SÍ, QUIERO MI REINICIO — 26€
          </button>

          <p className="text-sm mb-8" style={{
          color: '#9CA3AF'
        }} data-id="element-33">
            🔒 Pago 100% seguro · Acceso instantáneo · Garantía 7 días
          </p>

          <div className="flex flex-wrap justify-center gap-3" data-id="element-34">
            {['🔒 Pago Seguro', '⚡ Acceso Inmediato', '↩️ Garantía 7 Días', '🇪🇸 Creado en España'].map((badge, i) => <span key={i} className="text-gold text-xs md:text-sm font-semibold whitespace-nowrap" style={{
            background: 'rgba(27,94,59,0.1)',
            padding: '0.5rem 1rem',
            borderRadius: '9999px'
          }} data-id="element-35">
                {badge}
              </span>)}
          </div>
        </div>
      </section>

      {/* PAIN AMPLIFICATION */}
      <section className="bg-dark py-16 md:py-24" style={{
      padding: '4rem 1.5rem'
    }} data-id="element-36">
        <div className="container" style={{
        maxWidth: '72rem'
      }} data-id="element-37">
          <p className="text-gold text-xs md:text-sm uppercase text-center mb-6 font-semibold" style={{
          letterSpacing: '0.1em'
        }} data-id="element-38">
            ¿TE IDENTIFICAS CON ESTO?
          </p>

          <h2 className="font-serif text-white text-2xl md:text-4xl text-center mb-4 mx-auto leading-tight" style={{
          maxWidth: '48rem'
        }} data-id="element-39">
            "Pensé que estar cansada, hinchada y sin energía... era simplemente
            parte de hacerse mayor."
          </h2>

          <p className="text-gold italic text-lg md:text-xl text-center mb-12" data-id="element-40">
            — Lo que nadie te dijo es que hay una causa real. Y tiene solución.
          </p>

          <div className="grid grid-1 md:grid-2 mb-12" style={{
          gap: '1.25rem'
        }} data-id="element-41">
            {[{
            icon: '🧠',
            title: 'La Neblina Mental Constante',
            text: 'Te cuesta concentrarte más de 20 minutos. Olvidas cosas simples. Sientes que tu cerebro funciona al 40% de su capacidad. Y el café ya no ayuda.'
          }, {
            icon: '😴',
            title: 'Despiertas Agotado/a',
            text: 'Duermes 8 horas y amaneces destrozado/a. Tu cuerpo no descansa porque por dentro hay un incendio activo que consume toda tu energía de recuperación.'
          }, {
            icon: '👖',
            title: 'El Vientre que Crece Después de Comer',
            text: 'Comes "sano" pero a las 6 PM tu abdomen parece un globo. No es lo que comes, es lo que tu flora intestinal destruida no puede procesar.'
          }, {
            icon: '😤',
            title: 'Los Antojos que No Puedes Controlar',
            text: 'No es falta de voluntad. Son bacterias oportunistas en tu intestino enviando señales falsas a tu cerebro para que les alimentes con azúcar.'
          }, {
            icon: '🎭',
            title: 'El Humor que Cambia Sin Razón',
            text: 'Irritabilidad, ansiedad leve, bajones emocionales. El 95% de la serotonina se produce en el intestino. Si tu intestino está en guerra, tu mente también.'
          }, {
            icon: '⚖️',
            title: 'El Peso que No Se Va',
            text: 'Haces dieta, haces ejercicio, y la báscula no se mueve. La inflamación sistémica bloquea activamente las hormonas que regulan tu metabolismo.'
          }].map((card, i) => <div key={i} className="card" style={{
            background: 'rgba(27,94,59,0.1)',
            border: '1px solid rgba(201,168,76,0.2)',
            borderRadius: '1rem',
            padding: '1.5rem'
          }} data-id="element-42">
                <div style={{
              fontSize: '2.25rem',
              marginBottom: '1rem',
              width: '48px',
              height: '48px'
            }} data-id="element-43">
                  {card.icon}
                </div>
                <h3 className="text-gold font-bold text-lg mb-3" data-id="element-44">
                  {card.title}
                </h3>
                <p className="text-white text-sm md:text-base leading-relaxed" data-id="element-45">
                  {card.text}
                </p>
              </div>)}
          </div>

          <p className="text-white text-center italic text-base md:text-lg mx-auto leading-relaxed" style={{
          maxWidth: '42rem'
        }} data-id="element-46">
            Si reconoces 2 o más de estos síntomas, tu cuerpo lleva meses
            enviándote señales de auxilio. Cada día que pasa sin actuar, el
            incendio interno se hace más difícil de apagar.
          </p>
        </div>
      </section>

      {/* THE MECHANISM */}
      <section className="bg-light py-16 md:py-24" style={{
      padding: '4rem 1.5rem'
    }} data-id="element-47">
        <div className="container" style={{
        maxWidth: '72rem'
      }} data-id="element-48">
          <p className="text-xs md:text-sm uppercase text-center mb-6 font-semibold" style={{
          color: 'var(--emerald)',
          letterSpacing: '0.1em'
        }} data-id="element-49">
            LA CAUSA RAÍZ QUE NADIE TE EXPLICA
          </p>

          <h2 className="font-serif text-2xl md:text-4xl text-center mb-12 leading-tight" style={{
          color: 'var(--dark)',
          marginBottom: '4rem'
        }} data-id="element-50">
            El Problema No Es Tu Fuerza de Voluntad.
            <br data-id="element-51" />
            Es Tu Microbioma Destruido.
          </h2>

          <div className="grid grid-1 md:grid-3 mb-12" style={{
          gap: '2rem',
          marginBottom: '4rem'
        }} data-id="element-52">
            {[{
            icon: '🦠',
            title: 'EL DETONANTE',
            text: 'Azúcares ocultos, aceites procesados y aditivos en productos "fit" destruyen tu barrera intestinal silenciosamente.'
          }, {
            icon: '🔥',
            title: 'EL INCENDIO',
            text: 'Las bacterias oportunistas colonizan tu intestino y generan inflamación sistémica crónica que afecta cerebro, metabolismo y energía.'
          }, {
            icon: '💊',
            title: 'EL ERROR',
            text: 'Tratamos los síntomas (café, ibuprofeno, dietas) en lugar de apagar el incendio en la raíz. El ciclo nunca termina.'
          }].map((step, i) => <div key={i} className="text-center" data-id="element-53">
                <div style={{
              fontSize: '3.75rem',
              marginBottom: '1rem',
              width: '64px',
              height: '64px',
              margin: '0 auto 1rem'
            }} data-id="element-54">
                  {step.icon}
                </div>
                <h3 className="font-bold text-lg md:text-xl mb-3 uppercase" style={{
              color: 'var(--emerald)',
              letterSpacing: '0.05em'
            }} data-id="element-55">
                  {step.title}
                </h3>
                <p className="text-sm md:text-base leading-relaxed" style={{
              color: 'var(--gray-700)'
            }} data-id="element-56">
                  {step.text}
                </p>
              </div>)}
          </div>

          <div className="bg-emerald rounded-3xl p-8 md:p-12 text-center" data-id="element-57">
            <h3 className="font-serif text-gold text-2xl md:text-3xl mb-6" data-id="element-58">
              El Reinicio Biológico interrumpe ese ciclo en 14 días.
            </h3>
            <p className="text-white text-base md:text-lg leading-relaxed mx-auto" style={{
            maxWidth: '42rem'
          }} data-id="element-59">
              No es una dieta. No es un suplemento. Es un protocolo técnico de
              reprogramación del microbioma que actúa directamente sobre la
              causa raíz — no sobre los síntomas.
            </p>
          </div>
        </div>
      </section>

      {/* SOCIAL PROOF */}
      <section className="bg-white py-16 md:py-24" style={{
      padding: '4rem 1.5rem'
    }} data-id="element-60">
        <div className="container" style={{
        maxWidth: '72rem'
      }} data-id="element-61">
          <p className="text-gold text-xs md:text-sm uppercase text-center mb-6 font-semibold" style={{
          letterSpacing: '0.1em'
        }} data-id="element-62">
            RESULTADOS REALES DE PERSONAS REALES EN ESPAÑA
          </p>

          <h2 className="font-serif text-2xl md:text-4xl text-center mb-4" style={{
          color: 'var(--dark)'
        }} data-id="element-63">
            Más de 1.200 personas ya iniciaron su Reinicio
          </h2>

          <p className="text-center mb-12" style={{
          color: 'var(--gray-600)'
        }} data-id="element-64">
            Estos son algunos de sus mensajes reales:
          </p>

          <div className="grid grid-1 md:grid-2 mb-12" style={{
          gap: '1.5rem'
        }} data-id="element-65">
            {[{
            name: 'Lucía M. — Madrid',
            message: 'Día 4 y la neblina mental desapareció por completo. Llevo años sin sentirme tan lúcida en el trabajo. ¿Cómo no me enteré antes de esto? 🤯',
            time: '10:42 AM · Ayer'
          }, {
            name: 'Paco R. — Sevilla',
            message: 'El pantalón que no me cerraba desde hace 2 años... me lo puse hoy sin esfuerzo. Día 9. No me lo creo. El vientre por fin normal después de comer 🙌',
            time: '16:15 PM · Hace 2 días'
          }, {
            name: 'Ana C. — Barcelona',
            message: 'Empecé con mucho escepticismo. Pero en el día 6 me di cuenta de que llevaba días sin necesitar la siesta de las 3. Esto es diferente a todo lo que había probado antes. Increíble.',
            time: '20:30 PM · Hace 3 días'
          }, {
            name: 'Roberto S. — Valencia',
            message: 'Los antojos de azúcar desaparecieron casi de golpe. Mi mujer me pregunta qué estoy tomando 😂 Le he mandado el enlace. Ojalá lo hubiera encontrado hace 5 años.',
            time: '09:15 AM · Hace 4 días'
          }].map((t, i) => <div key={i} className="testimonial" data-id="element-66">
                <div className="testimonial-header flex items-center gap-3" data-id="element-67">
                  <div className="flex items-center justify-center text-white font-bold" style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: 'var(--gold)'
              }} data-id="element-68">
                    {t.name[0]}
                  </div>
                  <p className="text-white font-semibold text-sm flex items-center gap-2" data-id="element-69">
                    {t.name}
                    <span style={{
                  color: '#60A5FA'
                }} data-id="element-70">
                      ✓
                    </span>
                  </p>
                </div>
                <div className="p-6" data-id="element-71">
                  <div className="testimonial-bubble mb-3" data-id="element-72">
                    <p className="text-sm md:text-base leading-relaxed" style={{
                  color: '#1F2937'
                }} data-id="element-73">
                      {t.message}
                    </p>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-74">
                    <p className="text-xs" style={{
                  color: '#6B7280'
                }} data-id="element-75">
                      {t.time}
                    </p>
                    <div className="flex gap-1" data-id="element-76">
                      {[...Array(5)].map((_, j) => <span key={j} className="text-gold" data-id="element-77">
                          ⭐
                        </span>)}
                    </div>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="grid grid-1 md:grid-3 text-center" style={{
          gap: '2rem',
          paddingTop: '2rem',
          borderTop: '1px solid #E5E7EB'
        }} data-id="element-78">
            {[{
            number: '1.200+',
            label: 'Personas'
          }, {
            number: '4.8/5',
            label: 'Valoración Media'
          }, {
            number: '97%',
            label: 'Repiten'
          }].map((stat, i) => <div key={i} data-id="element-79">
                <p className="text-gold text-3xl md:text-4xl font-serif font-bold mb-1" data-id="element-80">
                  {stat.number}
                </p>
                <p className="text-sm md:text-base" style={{
              color: 'var(--gray-600)'
            }} data-id="element-81">
                  {stat.label}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* OFFER STACK */}
      <section className="bg-light py-16 md:py-24" style={{
      padding: '4rem 1.5rem'
    }} data-id="element-82">
        <div className="container" style={{
        maxWidth: '64rem'
      }} data-id="element-83">
          <p className="text-gold text-xs md:text-sm uppercase text-center mb-6 font-semibold" style={{
          letterSpacing: '0.1em'
        }} data-id="element-84">
            TODO LO QUE RECIBES HOY
          </p>

          <h2 className="font-serif text-2xl md:text-4xl text-center mb-12" style={{
          color: 'var(--dark)'
        }} data-id="element-85">
            Acceso Completo al Sistema Zeklo
          </h2>

          <div className="grid grid-1 md:grid-2 mb-12" style={{
          gap: '1.25rem'
        }} data-id="element-86">
            {[{
            icon: '📗',
            image: 'https://cdn.magicpatterns.com/uploads/kpqeeJXPW4oe2uvVr6ePv9/LIBRO_EL_REINICIO_BIOLOGICO_2B_BONOS_(1)_(1).png',
            name: 'Libro "El Reinicio Biológico"',
            description: 'El protocolo técnico de 14 días. Tu manual de batalla completo.',
            value: '97€'
          }, {
            icon: '🗺️',
            image: 'https://cdn.magicpatterns.com/uploads/2tnd4ucKUWpTuffMabV8WU/BONO_1_(1)_(1).webp',
            name: 'BONO 1 — Hoja de Ruta',
            description: 'Tu guía paso a paso, día a día. Cero dudas. Cero improvisación.',
            value: '27€'
          }, {
            icon: '🥗',
            image: 'https://cdn.magicpatterns.com/uploads/1ANDgCzmuhPzhs35EPv9LL/BONO_2_(1)_(1).webp',
            name: 'BONO 2 — Recetario Express',
            description: 'Comidas de menos de 10 minutos que alimentan tu biología, no la inflamación.',
            value: '47€'
          }, {
            icon: '⚠️',
            image: 'https://cdn.magicpatterns.com/uploads/nYyhZ1KyrmYFNpFP79odtJ/BONO_3_(2).webp',
            name: 'BONO 3 — Guía de Saboteadores',
            description: 'Todos los ingredientes ocultos en tu despensa que están destruyendo tu esfuerzo en el supermercado.',
            value: '17€'
          }, {
            icon: '🛒',
            image: 'https://cdn.magicpatterns.com/uploads/xBeJt6bGpHWh86cqtUaqGA/BONO_4_(1)_(1).webp',
            name: 'BONO 4 — Lista de Compras Inteligente',
            description: 'El inventario exacto para empezar desde hoy. Nada que inventarse.',
            value: '17€'
          }].map((item, i) => <div key={i} className="card card-border flex gap-4" data-id="element-87">
                <img src={item.image} alt={item.name} loading="lazy" width="80" height="80" style={{
              width: '80px',
              height: '80px',
              borderRadius: '0.5rem',
              objectFit: 'cover',
              flexShrink: 0
            }} data-id="element-88" />
                <div style={{
              flex: 1
            }} data-id="element-89">
                  <h3 className="font-bold text-base md:text-lg mb-2" style={{
                color: 'var(--dark)'
              }} data-id="element-90">
                    {item.name}
                  </h3>
                  <p className="text-sm mb-3 leading-relaxed" style={{
                color: 'var(--gray-600)'
              }} data-id="element-91">
                    {item.description}
                  </p>
                  <span className="text-gold text-xs font-semibold" style={{
                display: 'inline-block',
                background: 'rgba(201,168,76,0.2)',
                padding: '0.25rem 0.75rem',
                borderRadius: '9999px'
              }} data-id="element-92">
                    Valor: {item.value}
                  </span>
                </div>
              </div>)}
          </div>

          <div className="bg-dark rounded-3xl p-8 md:p-12 text-center" data-id="element-93">
            <p className="text-sm uppercase mb-2" style={{
            color: '#9CA3AF',
            letterSpacing: '0.05em'
          }} data-id="element-94">
              VALOR TOTAL DEL SISTEMA:
            </p>
            <p className="text-2xl md:text-3xl mb-4" style={{
            color: '#EF4444'
          }} data-id="element-95">
              <span className="price-strike" data-id="element-96">205€</span>
            </p>
            <p className="text-gold text-base uppercase mb-2" style={{
            letterSpacing: '0.05em'
          }} data-id="element-97">
              TU INVERSIÓN HOY:
            </p>
            <p className="text-white text-5xl md:text-7xl font-serif font-bold mb-6" data-id="element-98">
              26€
            </p>
            <p className="text-sm mb-8" style={{
            color: '#9CA3AF'
          }} data-id="element-99">
              (IVA incluido)
            </p>

            <button onClick={handlePaymentClick} className="btn btn-primary w-full text-lg md:text-xl mb-4" style={{
            minHeight: '56px',
            padding: '1rem 2rem'
          }} data-id="element-100">
              🚀 QUIERO ACCESO COMPLETO — 26€
            </button>

            <p className="text-sm" style={{
            color: '#9CA3AF'
          }} data-id="element-101">
              ⚡ Acceso inmediato tras el pago
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-white py-16 md:py-24" style={{
      padding: '4rem 1.5rem'
    }} data-id="element-102">
        <div className="container" style={{
        maxWidth: '48rem'
      }} data-id="element-103">
          <h2 className="font-serif text-2xl md:text-4xl text-center mb-12" style={{
          color: 'var(--dark)'
        }} data-id="element-104">
            Tus Preguntas. Respondidas con Honestidad.
          </h2>

          <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }} data-id="element-105">
            {[{
            q: '¿Funciona aunque lleve años con estos síntomas?',
            a: 'Sí. El protocolo actúa a nivel del microbioma, que se regenera independientemente del tiempo que lleves con inflamación. De hecho, muchos usuarios con síntomas crónicos reportan los cambios más rápidos y dramáticos.'
          }, {
            q: '¿Tengo que hacer dieta estricta o pasar hambre?',
            a: 'Absolutamente no. El Reinicio Biológico no es una dieta restrictiva. Es un protocolo de alimentación inteligente que saciará más y te dará más energía — no menos.'
          }, {
            q: '¿En cuánto tiempo veré resultados reales?',
            a: 'La mayoría de usuarios reporta los primeros cambios entre el día 3 y el día 7. La claridad mental suele ser lo primero. El vientre y la energía, antes del día 14.'
          }, {
            q: '¿Es apto para hombres y mujeres?',
            a: '100%. La inflamación sistémica no discrimina. El protocolo está diseñado para funcionar en cualquier perfil biológico adulto.'
          }, {
            q: '¿Qué pasa si no funciona para mí?',
            a: 'Tienes 7 días completos para probarlo. Si no sientes la diferencia, te devolvemos el 100% del dinero. Sin preguntas. Sin formularios complicados.'
          }, {
            q: '¿Cómo accedo después del pago?',
            a: 'Inmediatamente. Recibirás un email con acceso a tu área de descarga en menos de 2 minutos. Compatible con móvil, tablet y ordenador.'
          }].map((faq, i) => <details key={i} data-id="element-106">
                <summary data-id="element-107">
                  <span className="text-base md:text-lg" style={{
                paddingRight: '1rem'
              }} data-id="element-108">
                    {faq.q}
                  </span>
                  <span className="icon" data-id="element-109">+</span>
                </summary>
                <div className="faq-answer" data-id="element-110">
                  <p className="text-sm md:text-base leading-relaxed" style={{
                color: 'var(--gray-600)'
              }} data-id="element-111">
                    {faq.a}
                  </p>
                </div>
              </details>)}
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="bg-dark py-16" style={{
      padding: '4rem 1.5rem'
    }} data-id="element-112">
        <div className="container text-center" style={{
        maxWidth: '42rem'
      }} data-id="element-113">
          <div style={{
          fontSize: '4.5rem',
          marginBottom: '1.5rem',
          width: '80px',
          height: '80px',
          margin: '0 auto 1.5rem'
        }} data-id="element-114">
            🛡️
          </div>

          <h2 className="font-serif text-gold text-2xl md:text-4xl mb-8" data-id="element-115">
            La Garantía Zeklo: Sin Riesgo. Sin Trampa.
          </h2>

          <p className="text-white text-base md:text-lg leading-relaxed mb-8" data-id="element-116">
            Tienes 7 días para probarlo todo. Aplica el protocolo. Siente la
            diferencia.
            <br data-id="element-117" />
            <br data-id="element-118" />
            Si después de 7 días no notas ningún cambio, te devolvemos el 100%
            de tu dinero. Sin preguntas. Sin formularios imposibles. Sin
            esperas. Solo un email y listo.
          </p>

          <p className="text-gold italic text-lg md:text-xl font-semibold" data-id="element-119">
            El riesgo es nuestro. El resultado es tuyo.
          </p>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-16 md:py-24" style={{
      background: 'linear-gradient(to bottom, var(--dark) 0%, var(--emerald) 100%)',
      padding: '4rem 1.5rem'
    }} data-id="element-120">
        <div className="container text-center" style={{
        maxWidth: '48rem'
      }} data-id="element-121">
          <h2 className="font-serif text-white text-2xl md:text-4xl mb-8" data-id="element-122">
            ¿Cuánto más vas a esperar?
          </h2>

          <p className="text-white text-base md:text-lg leading-relaxed mb-8 mx-auto" style={{
          maxWidth: '42rem'
        }} data-id="element-123">
            Cada día que pasa con inflamación activa, la neblina crece. El
            vientre empeora. La energía se agota más. No es dramático — es
            biología.
          </p>

          <ul className="text-gold text-left mx-auto mb-8" style={{
          maxWidth: '36rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.75rem'
        }} data-id="element-124">
            <li className="flex items-start gap-3" data-id="element-125">
              <span style={{
              fontSize: '1.25rem'
            }} data-id="element-126">
                •
              </span>
              <span data-id="element-127">Otro día despertando destrozado/a</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-128">
              <span style={{
              fontSize: '1.25rem'
            }} data-id="element-129">
                •
              </span>
              <span data-id="element-130">Otra tarde con el vientre hinchado</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-131">
              <span style={{
              fontSize: '1.25rem'
            }} data-id="element-132">
                •
              </span>
              <span data-id="element-133">Otra reunión sin poder concentrarte</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-134">
              <span style={{
              fontSize: '1.25rem'
            }} data-id="element-135">
                •
              </span>
              <span data-id="element-136">Otro año sin ser quien realmente eres</span>
            </li>
          </ul>

          <p className="text-white italic text-lg md:text-xl mb-12" data-id="element-137">
            O puedes elegir diferente. Hoy. Por 26€.
          </p>

          <div className="rounded-3xl p-8 md:p-10 mb-8" style={{
          background: 'rgba(255,255,255,0.05)',
          border: '2px solid var(--gold)'
        }} data-id="element-138">
            <p className="text-xl md:text-2xl mb-3" style={{
            color: '#EF4444'
          }} data-id="element-139">
              <span className="price-strike" data-id="element-140">205€</span>
            </p>
            <p className="text-gold text-4xl md:text-6xl font-serif font-bold mb-3" data-id="element-141">
              HORA DE REINICIAR: 26€
            </p>
            <p className="text-sm mb-8" style={{
            color: '#D1D5DB'
          }} data-id="element-142">
              (IVA incluido · Acceso inmediato)
            </p>

            <button onClick={handlePaymentClick} className="btn btn-primary w-full text-lg md:text-2xl mb-6" style={{
            minHeight: '60px',
            padding: '1.5rem 2rem'
          }} data-id="element-143">
              ⚡ SÍ, QUIERO MI REINICIO BIOLÓGICO — 26€
            </button>

            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            fontSize: '0.875rem',
            color: '#D1D5DB'
          }} data-id="element-144">
              <p data-id="element-145">🔒 Pago 100% seguro</p>
              <p data-id="element-146">📱 Acceso instantáneo en móvil y ordenador</p>
              <p data-id="element-147">↩️ Garantía de devolución 7 días sin preguntas</p>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-12" style={{
      background: '#0A0A0A',
      padding: '3rem 1.5rem'
    }} data-id="element-148">
        <div className="container text-center" style={{
        maxWidth: '56rem'
      }} data-id="element-149">
          <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-6" style={{
          fontSize: '0.875rem',
          color: '#9CA3AF'
        }} data-id="element-150">
            <button onClick={() => setOpenModal('terms')} className="transition" style={{
            background: 'none',
            border: 'none',
            color: '#9CA3AF',
            cursor: 'pointer'
          }} data-id="element-151">
              Términos y Condiciones
            </button>
            <span className="hidden md:inline" data-id="element-152">·</span>
            <button onClick={() => setOpenModal('privacy')} className="transition" style={{
            background: 'none',
            border: 'none',
            color: '#9CA3AF',
            cursor: 'pointer'
          }} data-id="element-153">
              Política de Privacidad
            </button>
            <span className="hidden md:inline" data-id="element-154">·</span>
            <a href="mailto:zeklo.club@gmail.com" className="transition" style={{
            color: '#9CA3AF',
            textDecoration: 'none'
          }} data-id="element-155">
              Contacto
            </a>
          </div>

          <p className="text-xs md:text-sm mb-4" style={{
          color: '#6B7280'
        }} data-id="element-156">
            © 2026 Zeklo Club. Todos los derechos reservados.
          </p>

          <p className="text-xs italic mx-auto leading-relaxed" style={{
          color: '#4B5563',
          maxWidth: '42rem'
        }} data-id="element-157">
            Este producto no sustituye el consejo médico profesional. Los
            resultados individuales pueden variar según la persona.
          </p>
        </div>
      </footer>

      {/* Modals */}
      <Modal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-158">
        <Suspense fallback={<div className="text-center py-8" data-id="element-160">Cargando...</div>} data-id="element-159">
          <TermsAndConditions data-id="element-161" />
        </Suspense>
      </Modal>

      <Modal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-162">
        <Suspense fallback={<div className="text-center py-8" data-id="element-164">Cargando...</div>} data-id="element-163">
          <PrivacyPolicy data-id="element-165" />
        </Suspense>
      </Modal>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-166">
      <Routes data-id="element-167">
        <Route path="/" element={<Home data-id="element-169" />} data-id="element-168" />
      </Routes>
    </BrowserRouter>;
}